usuario.component('usuario.faturasComponent', {
    templateUrl: 'usuario/faturas/faturas.html',
    controller: 'usuario.faturasController',
    bindings: { baseUsuario: '<' }
});

usuario.controller('usuario.faturasController', ['$scope', 'coreLanguage', function($scope, $text) {
    $scope.$text = $text;
    const $ctrl = this;
}]);